







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatReferenceFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class FormatReferenceFilter extends Mixins(ModelEditableMixin) {
  editingSource: FormatReferenceFilterParameter;

  get name(): StringFilterParameter {
    return this.editingSource.name;
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.name = source);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }
}
